import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Translator } from 'angular-translator';
import { Marketplace } from 'app/infrastructure/model/classes/marketplace.class';
import {
  MarketplaceService,
  MARKETPLACE_ITEMTYPE_BusinessLogic,
  MARKETPLACE_ITEMTYPE_StandardFlow,
} from 'app/infrastructure/services/marketplace.service';

@Component({
  selector: 'marketplace-subscription',
  templateUrl: './marketplace-subscription.component.html',
  styleUrls: ['./marketplace-subscription.component.scss'],
})
export class MarketplaceSubscriptionComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  documentKind: string;
  standardKey: string;
  subcriptionType: string;
  expand: boolean;
  cardExpandedId: any;
  marketplaceItems: Marketplace[];
  marketplaceItemsFiltered: Marketplace[];

  constructor(
    public router: Router,
    protected aRoute: ActivatedRoute,
    public translate: Translator,
    private marketplaceService: MarketplaceService
  ) {
    this.aRoute.data.subscribe((data: Params) => {
      this.subcriptionType = data.type;
    });
  }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params['codorganizacion'];
      this.subscriptionCode = params['codsistema'];
      this.channelCode = params['codnegocio'];
      this.productCode = params['codproducto'];
      this.documentKind = params['documentKind'];

      if (this.subcriptionType === MARKETPLACE_ITEMTYPE_BusinessLogic) {
        this.marketplaceService
          .getAllWithContext(
            this.organizationCode,
            this.subscriptionCode,
            this.channelCode,
            this.productCode
          )
          .subscribe((res) => {
            this.marketplaceItems = res;
            this.marketplaceItemsFiltered = this.marketplaceItems;
          });
      }
      if (this.subcriptionType === MARKETPLACE_ITEMTYPE_StandardFlow) {
        this.marketplaceService
          .getStandardProductFlowsForUnbinded(
            this.subscriptionCode,
            this.channelCode,
            this.productCode,
            this.documentKind,
            this.standardKey
          )
          .subscribe((x) => {
            this.marketplaceItems = x;
            this.marketplaceItemsFiltered = this.marketplaceItems;
            console.log()
          });
      }
    });
  }

  isExpanded(event) {
    this.cardExpandedId = event.id;
    this.expand = event.expand;
  }

  filtersEvent(filters: any) {
    const search = filters.search;
    if (search) {
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) =>
          item.description.toLowerCase().includes(search.toLowerCase()) ||
          item.code.toLowerCase().includes(search.toLowerCase())
      );
    } else {
      this.marketplaceItemsFiltered = this.marketplaceItems;
    }
  }

  subscriptionEvent(model: Marketplace) {
    if (this.subcriptionType === MARKETPLACE_ITEMTYPE_BusinessLogic) {
      const businessContext = {
        organizationCode: this.organizationCode,
        subscriptionCode: this.subscriptionCode,
        channelCode: this.channelCode,
        productCode: this.productCode,
        businessLogicId: [`${model.id}`],
      };

      this.marketplaceService
        .businessSubscription(businessContext)
        .subscribe((resp) => {
          if (resp) this.volver();
        });
    }
    if (this.subcriptionType === MARKETPLACE_ITEMTYPE_StandardFlow) {
      this.marketplaceService
        .subscribeStandardProductFlow(
          this.subscriptionCode,
          this.channelCode,
          this.productCode,
          this.documentKind,
          this.standardKey,
          [model.code]
        )
        .then((x) => this.volver());
    }
  }

  volver() {
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/marketplace/marketplace-subscription.component.ts